// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cs1-h6 {
  font-weight: bold;
  font-size: 14px;
}

.cursor-pointer {
  cursor: pointer;
}

.button-cs1 {
  margin: -5px 3px;
  float: right;
}

.pt-10 {
  padding-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/grants/grants-application-ext/grants-audiences/grants-audiences.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".cs1-h6{\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n}\r\n\r\n.cursor-pointer{\r\n  cursor:pointer;\r\n}\r\n\r\n.button-cs1{\r\n  margin: -5px 3px;\r\n  float:right;\r\n}\r\n\r\n.pt-10{\r\n  padding-top: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
